import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel,
  WeGoAuthorizedLink,
  Permission,
  PermissionType,
  RoleLevel
} from '../../shared/config';
import { InterfaceStatusModel } from '../models/interfacestatus.model';
import { InterfaceStatusService } from '../models/interfacestatus.service';
import { CustomerService } from '../../customer/models/customer.service';
import { DropdownModel } from '../../report/models/report-filter.model';
import { InstanceService } from '../../instance/models/instance.service';
const $ = require('jquery');
const moment = require('moment');
const SlimSelect = require('slim-select');

@Component({
  selector: 'interfacestatus-list',
  template: require('../views/interfacestatus-list.component.html'),
  providers: [InterfaceStatusService, CustomerService, InstanceService],
  styles: [
    `
    .search-icon {
        color:#2ba2aa;
    }
    .reset-icon {
        color:#DD9933;
    }
    .export-icon {
        color:#01A2D9;
    }
    .delete-icon {
        color:#f00;
    }
    .cancel-icon {
        color:#f00;
    }
    .add-icon {
        color:#080;
    }
    .nopad-left{
      padding-left: 0px;
    }
    `
  ]
})
export class InterfaceStatusListComponent implements OnInit {
  DataListModel: DataListModel;
  interfaceStatusList: InterfaceStatusModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  private module: string;
  public breadCrumbList: string;
  apiResponse: IAPIResponse;
  customerList: DropdownModel[] = [];
  model: InterfaceStatusModel;
  instanceList: any;
  instanceMultiSelect: any;

  pageName: string;
  constructor(
    private interfaceStatusService: InterfaceStatusService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private customerService: CustomerService,
    private instanceService: InstanceService
  ) {}

  ngOnInit() {
    this.pageName = 'Interface_Status';
    this.model = new InterfaceStatusModel();
    this.module = this.translate.instant('LblInterfaceStatus');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.DataListModel.searchField = ['instanceName', 'status'];
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.GetInterfaceStatusList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetInterfaceStatusList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetInterfaceStatusList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetInterfaceStatusList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetInterfaceStatusList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.interfaceStatusService
      .ExportInterfaceStatus(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res) {
            let fileName =
              'InterfaceStatus_' + new Date().toISOString() + '.csv';
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public GetInterfaceStatusList() {
    this.isLoading = true;
    this.interfaceStatusService
      .GetInterfaceStatusList(this.DataListModel)
      .subscribe(
        res => {
          this.interfaceStatusList = res.data;
          console.log(res.data);
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/interfacestatus/components/interfacestatus-list.component.ts